import React, { PureComponent } from 'react'
// import { adminLoginRefresh } from '../../../api'
import get from 'lodash.get'
import { userActions } from '../../../redux/actions/user'
import { connect } from 'react-redux'
import jwtDecode from 'jwt-decode'
import PropTypes from 'prop-types'
import { authenticateRefresh } from '../../../api'

const MILLISECONDS_10_MIN = 1000 * 60 * 10

class Auth extends PureComponent {
  state = {
    timer: null,
    valid: false
  }
  abortController = new AbortController()

  componentDidMount () {
    const accessToken = get(this.props.user, 'accessToken', null)
    const payload = this.decodeJwtToken(accessToken)
    if (payload === null) {
      this.props.logout()
      return
    }
    this.setTokenRefreshInterval(60 * 1000)
    if (this.isJwtExpired(payload.exp, 0)) {
      this.props.logout()
      return
    }
    this.setState({ valid: true })
  }

  componentWillUnmount () {
    this.clearTimer()
    this.abortController.abort()
  }

  setTokenRefreshInterval = (timeout) => {
    const timer = window.setInterval(() => {
      this.tokenRefresh()
    }, timeout)
    this.setState({
      timer
    })
  }

  decodeJwtToken (token) {
    try {
      return jwtDecode(token)
    } catch (e) {
      return null
    }
  }

  clearTimer = () => {
    const { timer } = this.state
    if (timer) {
      clearInterval(timer)
    }
  }

  tokenRefresh () {
    const accessToken = get(this.props.user, 'accessToken', null)
    const payload = this.decodeJwtToken(accessToken)
    if (!payload) {
      this.props.logout()
      return
    }
    if (this.isJwtExpired(payload.exp, 0)) {
      this.props.logout()
      return
    }
    if (this.isJwtExpired(payload.exp, MILLISECONDS_10_MIN)) {
      this.refreshToken().then(() => {
        this.setState({ valid: true })
      }).catch(() => {
      })
    }
  }

  async refreshToken () {
    this.abortController.abort()
    this.abortController = new AbortController()
    const { fetchPromise } = authenticateRefresh()
    let tokens = await fetchPromise
    this.props.setToken(tokens.token)
  }

  isJwtExpired (exp, withinNextMilliseconds = 0) {
    if (isNaN(exp)) {
      return true
    }
    const expiration = new Date(exp * 1000)
    const now = new Date()
    return expiration.getTime() - now.getTime() < withinNextMilliseconds
  }

  render () {
    return (
      <React.Fragment>{this.state.valid ? this.props.children : null}</React.Fragment>
    )
  }
}

Auth.propTypes = {
  children: PropTypes.any.isRequired,
  user: PropTypes.object.isRequired,
  logout: PropTypes.func.isRequired,
  setToken: PropTypes.func.isRequired
}

const mapStateToProps = (state) => {
  return {
    user: state.user
  }
}

const mapDispatchToProps = {
  logout: userActions.logout,
  setToken: userActions.setToken
}

export default connect(mapStateToProps, mapDispatchToProps)(Auth)
